import React from 'react';

import { ReactComponent as CloseIcon } from '@assets/svg/cross.svg';

import SensorCharts from '@pages/SensorDetails/components/SensorCharts/SensorCharts';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

const ChartsModal = ({ point }) => {
  const { setModalClose } = useModalActions();

  return (
    <div className={style.chartsModal}>
      <CloseIcon className={style.closeIcon} onClick={setModalClose} />
      <div className={style.modalBody}>
        <SensorCharts point={point} isModal={true} />
      </div>
    </div>
  );
};

export default ChartsModal;
